import React, { useEffect } from 'react'
import './ImportantInfo.scss'
import scheduleJSON from './data/data'
import Button from '@material-ui/core/Button'

function ContactHeaders(props) {
  const { contacts } = props
  return (
    <tr>
      <th>Name</th>
      <th>Phone</th>
      <th>Email</th>
    </tr>
  )
}

function CoronaVirus(props) {
  const { corona } = props
  const { primary, secondary } = corona
  return (
    <div>
      <div className='section-links'>
        { primary.map(link => {
          return (
            <Button className="block-button" variant='contained' color="secondary" disableElevation size='large'>
              <a href={`${link.url}`} target='_blank'>{link.text}</a>
            </Button>
          )
        }) }
      </div>

      <div className='section-links'>
        { secondary.map(link => {
          return (
            <Button variant='contained' disableElevation size='large'>
              <a href={`${link.url}`} target='_blank'>{link.text}</a>
            </Button>
          )
        }) }
      </div>
    </div>
  )
}

function ContactRows(props) {
  const { contacts } = props
  return contacts.map((contact, idx) => {
    const { name, phone, email } = contact
    return (
      <tr key={idx}>
        <td>{`${name}`}</td>
        <td>{`${phone}`}</td>
        <td>
          {email ? (
            <Button variant='contained' disableElevation size='small'>
              <a href={`mailto:${email}`} target='_blank'>{`${email}`}</a>
            </Button>
          ) : (
            <span>-</span>
          )}
        </td>
      </tr>
    )
  })
}

function ImportantContacts(props) {
  const { contacts } = props
  return (
    <table id="contacts">
      <thead>
        <ContactHeaders contacts={contacts} />
      </thead>
      <tbody>
        <ContactRows contacts={contacts} />
      </tbody>
    </table>
  )
}

function IteneraryPDF(props) {
  const { pdf } = props
  return (
    <Button variant='contained' disableElevation size='large'>
      <a href={`${pdf.url}`} target='_blank'>Click To Open PDF</a>
    </Button>
  )
}

function TripDocsFolder(props) {
  const { docs } = props
  return (
    <Button variant='contained' disableElevation size='large'>
      <a href={`${docs.url}`} target='_blank'>Click To Open Folder</a>
    </Button>
  )
}

function ImportantInfo() {
  useEffect(() => {
    window.scrollTo(0, 0)
  })

  const { contacts, pdf, docs, corona } = scheduleJSON
  return (
    <div id='important-info'>
      <h1>Important Info</h1>

      <h2>Coronavirus</h2>
      <CoronaVirus corona={corona}/>

      <h2>Contacts</h2>
      <ImportantContacts contacts={contacts} />

      <h2>Itenerary PDF</h2>
      <IteneraryPDF pdf={pdf} />

      {/* <h2>Trip Docs Folder</h2>
      <TripDocsFolder docs={docs} /> */}
      {/* <p>If you do not see a folder, try logging in using Google</p> */}

    </div>
  )
}

export default ImportantInfo;
